import { render, staticRenderFns } from "./btnFormatValue.vue?vue&type=template&id=e74867a0"
import script from "./btnFormatValue.vue?vue&type=script&lang=js"
export * from "./btnFormatValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports